<template>
    <el-container>
        <el-header></el-header>
        <el-main>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="6" :lg="8" :xl="8"><div class="grid-content"></div></el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                    <div class="card">
                        <div class="card-top">
                            <h4 class="font-20 m-b-5">Welcome Back !</h4>
                            <p class="text-white-50">Welcome to BTI Wireless RMA Process System</p>
                            <!-- <a href="/" class="logo logo-admin"><img src="../assets/img/logo-light.png" height="96" alt="logo"></a> -->
                            <a href="/" class="logo logo-admin"><img src="../assets/img/logo-light-c.png" height="96" alt="logo"></a>
                        </div>

                     <el-form :model="loginForm" :rules="rules" ref="loginFormRef">
                        <el-form-item prop="username" label="Username">
                            <el-input v-model="loginForm.username" ></el-input>
                        </el-form-item>
                        <el-form-item prop="password" label="Password">
                            <el-input v-model="loginForm.password" type="password"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="submiloginForm('loginFormRef')">Login</el-button>

                            <el-button type="primary" @click="regist">Register</el-button>
                        </el-form-item>
                    </el-form>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="6" :lg="8" :xl="8"><div class="grid-content"></div></el-col>

            </el-row>
        </el-main>

            <el-footer>Copyright © 2020 BTI Wireless Communications Co., Ltd. All rights reserved.</el-footer>

    </el-container>
</template>
<script>

    export default {
        data(){
            return {
                loginForm:{
                    username:"",
                    password:""
                },
                rules:{
                    username: [
                        { required: true, message: 'please enter user name', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: 'Please enter the password', trigger: 'blur' }
                    ],
                }
            }


        },
        created(){
            document.title = "Welcome to BTI Wireless’s RMA Process System";
        },
        methods: {
            submiloginForm(loginFormRef) {
                this.$refs[loginFormRef].validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    const result=await this.$http.post("user/login",this.loginForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        localStorage.setItem("token",result.data.data.token);
                        localStorage.setItem("expire_time",Date.now());
                        const userdata=await this.$http.get("user/infoself");

                        localStorage.setItem("username",userdata.data.data.name);
                        this.$router.push("/home");
                        const setformm=await this.$http.get("sysset/info");
                        localStorage.setItem("setform",JSON.stringify(setformm.data.data.setform));
                    }
                });
            },
            resetloginForm(loginFormRef) {
                this.$refs[loginFormRef].resetFields();
            },
            regist(){
                this.$router.push("regist")
                console.log(111);
            }
        },
    }
</script>
<style lang="less" scoped>

    .el-col{
        margin-top: 50px;
    }
    .grid-content{
        min-height: 1px;
    }
    .el-row{
        text-align: center;
        margin: auto;
    }
    .el-form-item{
        width: 80%;
        margin: 15px auto;
    }
    .el-form{
        padding-bottom: 30px;
    }
    .card-top{
        border-radius: .25rem;
        background-color: #626ed4 !important;
        color: #ffffff !important;
    }
    .card-top img{
        vertical-align: middle;
        border-style: none;
    }
    .card{
        position: relative;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 1px solid rgba(0,0,0,.125);
        border-radius: .25rem;
    }
    .wrapper-page .logo-admin {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -40px;
        margin: 0px auto;
        width: 74px;
        height: 74px;
        line-height: 74px;
        background: #ffffff;
        border-radius: 50%;
        border-bottom: 2px solid #02a499;
    }
    .logo {
        color: #2a3142 !important;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
    }
    h4{
        margin: 15px;
    }

    .text-white-50 {
        font-size: 14px;
        color: rgba(255,255,255,.5)!important;

        margin: 8px !important;
    }

    .text-center {
        text-align: center!important;
    }
    .el-button--primary{
        background-color: #626ed4 !important;
    }

</style>
